<div class="container-fluid">
  <div data-automation="teams-calling-container-nav" class="navbar pb-3">
    <div class="w-100">
      <ul ngbNav [(activeId)]="activeTab" class="nav-pills justify-content-start">
        <li [ngbNavItem]="tabs.CALLING" class="w-25">
          <a
            ngbNavLink
            data-automation="teams-calling-tab"
            class="btn nav-link text-center text-nowrap fs-5"
            [ngClass]="{ 'text-danger': hasCallingTabError }"
          >
            @if (hasCallingTabError) {
              <span
                [class]="
                  ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                "
              ></span>
            }
            {{ 'tkey;microsoft_360.view.teams.number_and_policies.title' | translate }}
          </a>
        </li>
        <li
          [ngbNavItem]="tabs.UNANSWERED_CALL_FORWARDING"
          [disabled]="!isDelegateManagementEnabled"
          [ngbTooltip]="delegateManagementDisabledTooltip | translate"
          [disableTooltip]="isDelegateManagementEnabled"
          [container]="'body'"
          (click)="isDelegateManagementEnabled && onForwardingTabSelected()"
        >
          <a
            ngbNavLink
            data-automation="unanswered-call-forwarding-tab"
            class="btn nav-link text-center text-nowrap fs-5"
            [ngClass]="{ 'text-danger': hasForwardingTabError }"
          >
            @if (hasForwardingTabError) {
              <span
                [class]="
                  ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                "
              ></span>
            }
            {{ 'tkey;microsoft_360.view.teams.call_forward_settings.title' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div [hidden]="activeTab !== tabs.CALLING">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  @if (!isLoading) {
    <ziro-microsoft-teams-calling-dial-plan-selector-form
      [microsoftDialPlanGroups]="microsoftDialPlanGroups"
      [upn]="upn"
      [teamsLine]="teamsLine"
      [voicePolicies]="voicePolicies"
      [isZpcSyncWarningPresent]="isZpcSyncWarningPresent"
      [isResourceAccount]="isResourceAccount"
      [ms360View]="ms360View"
      [sharedCallingPolicies]="sharedCallingPolicies"
      [tenantId]="tenantId"
    ></ziro-microsoft-teams-calling-dial-plan-selector-form>
  }
</div>

@if (isDelegateManagementEnabled) {
  <div [hidden]="activeTab !== tabs.UNANSWERED_CALL_FORWARDING">
    <ziro-unanswered-call-forwarding-settings
      [dialPlanGroupId]="selectedDialPlanGroupId"
    ></ziro-unanswered-call-forwarding-settings>
  </div>
}
